// mutations
export const RECEIVE_SEARCH_NEWS = 'RECEIVE_SEARCH_NEWS'
export const RECEIVE_SELECT_CATEGORY = 'RECEIVE_SELECT_CATEGORY'
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL'
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR'
export const AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS'



// WEBPACK FOOTER //
// ./src/app/config/store/modules/search/types.js